module.exports = __webpack_public_path__ + "img/419.29a63b72.png";